import { createStandardAction, getType, ActionType } from 'typesafe-actions';

import { RootAction } from '../../RootAction';

const OPEN_FAQ = 'PeeringWeb/FaqPage/OPEN_FAQ';
const CLOSE_FAQ = 'PeeringWeb/FaqPage/CLOSE_FAQ';

export const openFaq = createStandardAction(OPEN_FAQ)<number>();
export const closeFaq = createStandardAction(CLOSE_FAQ)();

export type Actions = ActionType<typeof closeFaq> | ActionType<typeof openFaq>;

export interface FaqPageState {
  openedFaqIndex: number | null;
}

const defaultState: FaqPageState = {
  openedFaqIndex: null,
};

export default (state: FaqPageState = defaultState, action: RootAction) => {
  switch (action.type) {
    case getType(openFaq):
      return {
        openedFaqIndex: action.payload,
      };
    case getType(closeFaq):
      return {
        openedFaqIndex: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /www/client/src/containers/FaqPage/faqPageDuck.ts